import PropTypes from 'prop-types';

import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import Stack from '@zenbusiness/zui/Stack';

import { BankingTransitionBanner } from '#client/components/BankingTransitionBanner';
import { ErrorStateSection } from '#client/components/ErrorStateSection';
import { HomeBanners } from '#client/components/HomeBanners';
import { NextUp } from '#client/components/NextUp';
import { OrderTracker } from '#client/components/OrderTracker';
import { PersonalizedModal } from '#client/components/PersonalizedModal';
import { ProductCategories } from '#client/components/ProductCategories';
import { VeloChat } from '#client/components/VeloChat';
import { VELO_REPLACE_NEXT_UP_CARDS } from '#client/constants/experimentsFlags';

import { StyledPageContainer } from './Home.style';

import DashboardWidgets from '../../components/Widgets/DashboardWidgets';

const Home = ({ loading }) => {
  const enableVeloNextUp = useExperimentFlag(VELO_REPLACE_NEXT_UP_CARDS, false);

  return (
    <StyledPageContainer>
      <Stack spacing={{ xs: 2, sm: 3 }}>
        <ErrorBoundary id="src/Home#BankingTransitionBanner">
          <BankingTransitionBanner />
        </ErrorBoundary>
        <HomeBanners />

        <ErrorBoundary id="src/Home#NextUp" fallback={<ErrorStateSection title="Next Up" />}>
          {enableVeloNextUp ? <VeloChat /> : <NextUp />}
        </ErrorBoundary>

        <ErrorBoundary id="src/Home#OrderStatus" fallback={<ErrorStateSection title="Order Status" />}>
          <OrderTracker />
        </ErrorBoundary>

        <ErrorBoundary id="src/Home#Widgets" fallback={<ErrorStateSection />}>
          <DashboardWidgets />
        </ErrorBoundary>

        <ErrorBoundary id="src/Home#ProductCards" fallback={<ErrorStateSection title="Products for your business" />}>
          <ProductCategories />
        </ErrorBoundary>
      </Stack>

      {!loading && (
        <ErrorBoundary id="src/Home#PersonalizedModal" fallback={<ErrorStateSection />}>
          <PersonalizedModal />
        </ErrorBoundary>
      )}
    </StyledPageContainer>
  );
};

Home.propTypes = {
  loading: PropTypes.bool,
};

export default Home;
